export const VISITS_GET = 'getVisits';
export const VISITS_SET = 'setVisits';
export const SURVEY_SELECT = 'selectSurvey';
export const SELECTED_SURVEY_GET = 'selectedSurveyGet';
export const VISIT_SURVEYS_GET = 'getVisitSurveys';
export const SURVEY_ADD = 'addSurvey';
export const SURVEY_DELETE = 'deleteSurvey';
export const POSSIBLE_SURVEY_GET = 'getPossibleSurveys';
export const POSSIBLE_SURVEY_SET = 'setPossibleSurvey';
export const ATTACHMENTS_LIST_GET = 'getAttachmentsList';
export const ATTACHMENT_SET = 'setAttachment';
export const ATTACHMENT_DELETE = 'deleteAttachment';
export const CLEAR_ATTACHEMNTS_LIST = 'clearAttachmentsList';
export const CLEAR_SURVEYS_LIST = 'clearSurveysList';
export const SHOW_PROGRESS = 'showProgress';
export const SET_PROGRESS = 'setProgress';
export const SET_READONLY_MODE = 'setReadonlyMode';
export const POINTER_ADD = 'addPointer';
export const POINTER_DELETE = 'deletePointer';
export const POINTER_GET = 'getPointer';
export const BODY_PART_DATA_GET = 'getBodyPartNames';
export const CUSTOMER_HISTORY_GET = 'getCustomerHistory';
export const BOOKING_ADD = 'addBooking';
export const TIMEZONE_NAME_SET = 'setTimezone';
export const CLEAR_CUSTOMER_HISTORY = 'clearCustomerHistory';
export const VISIT_SELECT = 'selectVisit';
export const VISIT_SELECT_FORMS = 'selectVisitForms';
export const CUSTOMER_SET = 'setCustomer';
export const TOGGLE_VISIT_FORM = 'toggleVisitForm';
export const SHOW_ONLY_FILLED_SET = 'setShowOnlyFilled';
export const ATTACHMENT_ADD = 'addAttachment';
export const ATTACHMENT_LIST_SELECT = 'selectAttachmentList';
export const SET_CLOSED_VISIT = 'setClosedVisit';
export const SET_ACCESS_LEVEL = 'setACCESS_LEVEL';
export const BUSINESS_DETAILS_GET = 'getBusinessDetails';
export const BUSINESS_ADD = 'addBusiness';




// WEBPACK FOOTER //
// ./src/store/action-modulation.type.js